// extracted by mini-css-extract-plugin
module.exports = {"AuthorizationCheckWarning":"AuthorizationCheckWarning_AuthorizationCheckWarning__-tIGh"};